import { status } from "skin/event/status";

// В таблице роль формы сотрудника блокируем переход в форму
const emp = (obj, ms, story, data, d, action) => {
	if (obj.table === "tnk_empRole" && obj.action === "row") return fn(obj, story);
	return status.action;
};

export default emp;

function fn(obj, story) {
	const keyObj = obj.key;
	const row = story.s.tnk_emp.table.tnk_empRole.row;
	if (keyObj === row) return status.ignore;
	return status.action;
}
